import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import {ThemeProvider} from '@material-ui/core/styles';
import {fade,makeStyles} from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import useMediaQuery from '@material-ui/core/useMediaQuery';
import {useTheme} from '@material-ui/core/styles';
import customeTheme from '../../shared/Theme/Theme';

import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import MenuIcon from '@material-ui/icons/Menu';

import HomeIcon from '@material-ui/icons/Home';
import VideogameAssetIcon from '@material-ui/icons/VideogameAsset';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Person from '@material-ui/icons/Person';

import LogOutIcon from './LogOut.svg';
import SettingsIcon from '@material-ui/icons/Settings';

import './FeedHeader.scss';
import Logo from './Logo.svg';

function ElevationScroll(props) {
    const { children, window } = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
      disableHysteresis: true,
      threshold: 0,
      target: window ? window() : undefined,
    });
  
    return React.cloneElement(children, {
      elevation: trigger ? 4 : 0,
    });
  }

const useStyles = makeStyles(customeTheme => ({
    toolbarMargin: {
        ...customeTheme.mixins.toolbar,
        marginBottom:"2.5rem",
        [customeTheme.breakpoints.down("md")]: {
            marginBottom: "1.8rem"
        },
        [customeTheme.breakpoints.down("xs")]: {
            marginBottom: "1.5rem"
        },
    },
    appbar: {
        height:"4.5rem"
    },
    center: {
        display:"flex",
        justifyContent:"center",
        // alignItems:"center",
    },
    search: {
      position: 'relative',
      borderRadius: customeTheme.shape.borderRadius,
      backgroundColor: fade(customeTheme.palette.common.white, 0.15),
      '&:hover': {
        backgroundColor: fade(customeTheme.palette.common.white, 0.25),
      },
      marginRight: customeTheme.spacing(2),
      marginLeft: 0,
      width: '100%',
      [customeTheme.breakpoints.up('sm')]: {
        marginLeft: customeTheme.spacing(3),
        width: 'auto',
      }
    },
    searchIcon: {
      padding: customeTheme.spacing(0, 2),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    inputRoot: {
      color: 'inherit',
    },
    inputInput: {
      padding: customeTheme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${customeTheme.spacing(4)}px)`,
      transition: customeTheme.transitions.create('width'),
      width: '100%',
      [customeTheme.breakpoints.up('md')]: {
        width: '20ch',
    }},
    tabContainer:{
        marginLeft: "auto",
        marginRight:"3rem"
    },
    tab: {
        ...customeTheme.typography.tab,
        minWidth:"70px"
    },
    badge: {
        // backgroundColor: "#00AFD7",
        color: "white"
    },
    customButtonStyle: {
        //"&:hover, &.Mui-focusVisible":{backgroundColor:"#FFAD02"},
        // "&:active":{color:"#FFAD02"}
    },
    //Question: It can not change color
    menu: {
        backgroundColor: customeTheme.palette.common.test,
        color:"black",
    },
    listItemIcon: {
        ...customeTheme.typography.listItemIcon,
        opacity: 0.7,
        color:"black",
        "&:hover": {
            opacity: 1
        }
    },
    menuItem: {
        
    },
    logo: {
        // height:"8rem",
        /*
        [customeTheme.breakpoints.down("md")]: {
            height: "2rem"
        },
        [customeTheme.breakpoints.down('xs')]: {
            height: "2rem"
        }
        */
    },
    drawerIconContainer: {
        marginLeft: "auto",
        color:"#ffffff",
        "&:hover": {
            backgroundColor: "transparent",
        }
    },
    drawerIcon: {
        fontSize: "32px",
        marginRight:"1rem"
    },
    typography: {
        fontFamily: 'Montserrat',
    },
    drawer: {
        //bugs
        backgroundColor: customeTheme.palette.common.gameMeetDarkBlue,
    },
    drawerItem: {
        ...customeTheme.typography.tab,
    },
    dismiss: {
        [customeTheme.breakpoints.down('xs')]:{
            display:'none',
        }
    }
}))

function FeedHeader() {
    const classes = useStyles();
    const theme = useTheme();
    const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);
    const matches = useMediaQuery(theme.breakpoints.down("md"))
    const [openDrawer, setOpenDrawer] = useState(false);
    const searchbar = "searchbar";
    const [value, setValue] = useState(0);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openMenu, setOpenMenu] = useState(false);
    const test = "#E83A3A";
    const [selectedIndex, setSelectedIndex] = useState(0);

    const handleChange = (e,newValue) => {
        setValue(newValue)  
    };

    const handleClick = (e) => {
        setAnchorEl(e.currentTarget);
        setOpenMenu(true);
    }

    const handleClose = (e) => {
        setAnchorEl(null);
        setOpenMenu(false);
    }

    const handleMenuClick = (e, i) => {
        setAnchorEl(null);
        setOpenMenu(false);
        setSelectedIndex(i);
    };
 
    const menuOptions = [
     {name:"View Profile", link: "/profile", img:<Person fontSize="small"/>},
     {name:"Account Seting", link:"/accountseting", img:<SettingsIcon fontSize="small"/>},
     {name:"Log Out", link:"/", img:<img src={LogOutIcon} alt="GameMeet"/>},
    ];

    useEffect(() => {
        if (window.location.pathname === '/' && value !== 0) {
            setValue(0);   
        }else if (window.location.pathname != '/' && value === 2) {
            setValue(2);
        }else if (window.location.pathname === '/match' && value !== 1) {
            setValue(1);
        }else if (window.location.pathname === '/profile' && value !== 3) {
            setValue(3);
        }
        // const path = window.location.pathname;
        // switch (path) {
        //     case path === "/feed" && value !== 0:
        //         setValue(0);
        //         break;
        //     case path != '/feed' && value !== 2: 
        //         setValue(2);
        //         break;
        //     case path === "/match" && value !== 1:
        //         setValue(1);
        //         break;
        //     case path ==="/profile" && value !== 3:
        //         setValue(3);
        //         setSelectedIndex(1);
        //         break;
        //     default:
        //         break;
        // }
    }, [value]);

    const tabs = (
        <React.Fragment>
            <div className="navagation-bar">
                <Tabs 
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary" 
                    // variant="fullWidth"
                    // indicatorColor="secondary"
                    // textColor="third"
                    aria-label="icon tabs example"
                    className={classes.tabContainer}>
                    <Tab disableFocusRipple disableRipple className={classes.tab} component={Link} to="./feed" icon={<HomeIcon />} aria-label="home" />
                    <Tab disableFocusRipple disableRipple className={classes.tab} component={Link} to="./match" icon={<VideogameAssetIcon />} aria-label="match" />
                    <Tab 
                    label={
                        <Badge
                            // badgeContent={this.state.messageCount} color="primary"
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            badgeContent={3}
                            style={{ position:'absolute',
                                     top:'25px',
                                     right:'25px',
                            }}
                            color="error"
                        >
                        </Badge>
                    }
                    disableFocusRipple 
                    disableRipple 
                    className={classes.tab} 
                    icon={<NotificationsIcon />} aria-label="notification" 
                    />
                    <Tab 
                        disableFocusRipple disableRipple
                        aria-owns={anchorEl ? "profile-menu" : undefined}
                        aria-haspopup={anchorEl ? "true" : undefined}
                        className={classes.tab} 
                        onClick={event => handleClick(event)}
                        icon={<Person />} 
                        aria-label="profile" 
                    />
                </Tabs>
                <Menu 
                    id="profile-menu" 
                    anchorEl={anchorEl} 
                    open={openMenu}
                    onClose={handleClose}
                    elevation={0}
                    classes={{ paper: classes.menu }}
                    >
                    
                    {menuOptions.map((option, i) => {
                        return <MenuItem 
                            disableRipple
                            focusRipple={false}
                            key={i}
                            onClick={event => {
                                handleMenuClick(event,i);
                                setValue(3);
                                handleClose();
                            }}
                            selected={ i === selectedIndex && value === 3}
                            classes={{root: classes.menuItem}}    
                            component={Link} 
                            to={option.link}
                        >
                            <ListItemIcon
                                classes={{root: classes.listItemIcon}}
                            >
                                <div className="listItemIcon">
                                    {option.img}
                                </div>
                                <Typography variant="inherit">{option.name}</Typography>
                            </ListItemIcon>
                        </MenuItem>
                    })}
                </Menu>
            </div>
        </React.Fragment>
    )

    const drawer = (
        <React.Fragment>
            <SwipeableDrawer disableBackdropTransition={!iOS} disableDiscovery={iOS} 
                open={openDrawer}
                onClose={() => 
                    setOpenDrawer(false)
                }
                onOpen={() =>
                    setOpenDrawer(true)
                }
                classes={{paper:classes.drawer}}
            >
                <List>
                    <ListItem onClick={() => setOpenDrawer(false)} component={Link} to="/feed">
                        <ListItemText disableTypography>
                            Home
                        </ListItemText>
                    </ListItem>
                    <ListItem onClick={() => setOpenDrawer(false)} component={Link} to="/match">
                        <ListItemText disableTypography>
                            Match
                        </ListItemText>
                    </ListItem>
                    <ListItem onClick={() => setOpenDrawer(false)} component={Link} to="/profile">
                        <ListItemText disableTypography>
                            Profile
                        </ListItemText>
                    </ListItem>
                    <ListItem onClick={() => setOpenDrawer(false)} component={Link} to="/accountseting">
                        <ListItemText disableTypography>
                            Account Seeting
                        </ListItemText>
                    </ListItem>
                </List>
            </SwipeableDrawer>
            <IconButton 
                className={classes.drawerIconContainer}
                onClick={() => setOpenDrawer(!openDrawer)}
                disableRipple
                disableFocusRipple
            >
                <MenuIcon className={classes.drawerIcon}/>
            </IconButton>
        </React.Fragment>
    )

    return (
        <React.Fragment>
            <ThemeProvider theme={customeTheme}>
                <ElevationScroll>
                    <AppBar position="fixed" color="primary" className={`${classes.appbar} ${classes.center}`}>
                        <Toolbar disableGutters >
                            <div className="appbar-logo-container">
                                <Link to="/feed" onClick={()=> setValue(0)}>
                                    <img src={Logo} alt="GameMeet" className={classes.logo}/>
                                </Link>
                                <Typography className={`${classes.typography} ${classes.dismiss}`} variant="h5">
                                    GameMeet
                                </Typography>
                            </div>
                            <div className={`${classes.search} ${searchbar}`}>
                                <div className={classes.searchIcon}>
                                    <SearchIcon />
                                </div>
                                <InputBase
                                    placeholder="Search"
                                    classes={{
                                        root: classes.inputRoot,
                                        input: classes.inputInput,
                                        
                                    }}
                                    className={classes.typography}
                                    inputProps={{ 'aria-label': 'search' }}
                                />
                            </div>
                            {matches ? drawer : tabs}
                        </Toolbar>
                    </AppBar>
                </ElevationScroll>
                <div className={classes.toolbarMargin}></div>
            </ThemeProvider>
        </React.Fragment>
    );
}

export default FeedHeader


/*
<AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
        >
          <Badge
            badgeContent={4}
            style={{ marginTop: "1rem" }}
            color="secondary"
          >
            <Tab label="Item One" {...a11yProps(0)} />
          </Badge>
          <Tab label="Item Two" {...a11yProps(1)} />
          <Tab label="Item Three" {...a11yProps(2)} />
        </Tabs>
</AppBar>
*/